// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8f73029","147":"5961d603","295":"82dd6a34","574":"ff17616b","764":"4923f842","807":"a225643b","818":"0f10adc0","899":"45bcd0d5","900":"bbec8e99","996":"4aa35d15"}[chunkId] + ".chunk.js";
};